// src/app/pipes/currency.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: number | string): string {
    const formattedValue = parseFloat(value.toString()).toFixed(2);
    return `$${formattedValue.replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  }
}
